module.exports = __webpack_public_path__ + "img/agnes.92688cf3.png";